import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: space-between;
`

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: space-between;
  margin: 10px 0px;
`

export const FormField = styled(Container)`
  width: 100%;
  min-width: auto;
  justify-content: flex-end;
  padding: 0px;
`

export const Block = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 15px;
`

export const Row = styled.div`
  width: 100%;
  padding: 0px;
  margin-bottom: 5px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
`

export const BottomRow = styled(Row)`
  gap: 10px;
  margin: 0px;
  justify-content: center;
`

export const StatusGrid = styled.div`
  position: relative;
  display: grid;
  grid-template-rows: 1fr 1fr;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  justify-content: center;
  align-items: center;
  margin: 10px 0px;
  gap: 10px;
`

export const StatusBlock = styled.div`
  height: 38px;
  color: #FFFFFF;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: ${({ color }) => color};
  border-radius: 15px;
  margin: 0px;
  padding: 0px 12px;
  gap: 5px;
  cursor: ${({ disabled }) => disabled ? 'not-allowed' : 'pointer'};

  p {
    /* flex: 1; */
    color: #FFFFFF;
    text-align: left;
    line-height: 14px;
  }
`

export const StatusButton = styled.button`
  width: 24px;
  height: 24px;
  border: 0px;
  border-radius: 50%;
  margin-left: auto;
  margin-right: -6px;
  display: flex;
  justify-content: center;
  justify-self: flex-end;
  align-items: center;
  background-color: transparent;

  &:hover {
    background-color: #FFFFFF33;
  }
`

export const LoadingBackdrop = styled.div`
  position: absolute;
  top: 0px;
  width: 100%;
  height: 100%;
  background-color: #FFFFFFAA;
  border-radius: 15px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  z-index: 5;
`

export const CalendarContainer = styled(Container)`
  padding: 0px;
  margin: 0px 30px 0px 0px;
`

export const ImageContainer = styled.div`
  position: relative;
  border-radius: 10px;
`

export const RatingContainer = styled.span`
  display: flex;
  position: absolute;
  top: -6px;
  right: -6px;
  height: 18px;
  padding: 0px 6px 0px 4px;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 3px;
  background-color: #FFFFFF;
  border: 1px solid #EEEEEE;
  border-radius: 15px;

  p {
    font-size: 12px;
    line-height: 20px;
    font-weight: bold;
    text-align: center;
    margin: 0px;
  }
`

export const Image = styled.img`  
  width: 20px;
  height: 20px;
  margin-right: 5px;
`

export const MemberPicture = styled.img`
  width: 80px;
  height: 80px;
  box-shadow: 0px 2px 10px -6px #252525;
  border-radius: 15px;
  margin-bottom: 5px;
`

export const CustomerButton = styled.button`
  height: 38px;
  border: 0px;
  background-color: #FFFFFF;
  box-shadow: 0px 2px 10px -8px #252525;
  border-radius: 15px;
  text-align: center;
  
  &:hover {
    border: 1px solid #CCCCCC !important;
    outline: none;
  }

  &:hover p {
    color: #35A7FF;
  }
`

export const InfoText = styled.p`
  font-size: 14px;
  text-align: center;
  margin: 0px;
`

export const Title = styled(InfoText)`
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
`

export const SubTitle = styled(Title)`
  font-size: 14px;
  margin-bottom: 0px;
`

export const WhiteText = styled(InfoText)`
  color: #FFFFFF;
  font-size: 14px;
`

export const WarningText = styled(InfoText)`
  color: #FF3939;
`

export const Label = styled(InfoText)`
  margin-bottom: 5px;
  color: #777777;
`

export const ErrorContainer = styled.div`
  padding: 9px;
  margin: 10px 0px;
  width: 100%;
  border-radius: 15px;
  align-items: center;
  background-color: #FF3939;
`
